<script lang="ts" setup>
import { sleep } from '@antfu/utils';
import { Autoplay, FreeMode, Mousewheel } from 'swiper/modules';
import { Swiper } from 'swiper';
import type { Ref } from 'vue';
import type { Swiper as SwiperType } from 'swiper/types';
import type { Brand } from '~/types/Brand';

const { brands, showHeader = true } = defineProps<{
  brands: Brand[];
  showHeader?: boolean;
}>();

onMounted(async () => {
  await sleep(1000);
  sliderInitialization();
});

const brandsSwiper: Ref<SwiperType | null> = ref(null);
const brandsSwiperRef = ref();

function sliderInitialization() {
  brandsSwiper.value = new Swiper(brandsSwiperRef.value, {
    autoplay: { delay: 5000, pauseOnMouseEnter: true },
    freeMode: { sticky: true },
    loop: true,
    modules: [Autoplay, FreeMode, Mousewheel],
    mousewheel: { forceToAxis: true },
    slidesPerView: 'auto',
    speed: 1000,
  });
}
</script>

<template>
  <section class="brands-gallery">
    <AppLink
      v-if="showHeader"
      to="/brands"
    >
      <h2 class="inline underline underline-offset-4">Бренды</h2>
    </AppLink>

    <div
      ref="brandsSwiperRef"
      class="swiper w-full"
    >
      <div class="swiper-wrapper flex gap-2 md:gap-3 touch-pan-x">
        <div
          v-for="brand in brands"
          :key="brand.slug"
          class="swiper-slide !w-fit"
        >
          <AppLink :to="brand.uri">
            <BrandLogoBlock
              :brand
              show-title
            />
          </AppLink>
        </div>
      </div>
    </div>
  </section>
</template>

<style lang="scss">
.brands-gallery {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
</style>
